import React from "react"
import PropTypes from "prop-types"
import Grid from "@mui/material/Grid"

import Section from "../template-parts/product-marketing/Section"
import IconTextBlock from "../template-parts/product-marketing/IconTextBlock"

const allAboutLessons = {
  generic: [
    {
      head: "The Country's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the top driving educators.",
    },
    {
      head: "Will you Pass Your Test?",
      text: "Good drivers pass the test. So we focus on core skills first, ensuring you are set up to be safe and confident for life, before worrying about the test. On your last lesson, we will do a mock test to be sure you are ready!",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you. We will work with you if it is in your best interest to do more or fewer lessons.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
    {
      head: "Post-Lesson Report Included",
      text: "At the end of your lesson, your instructor fills out a post-lesson report that shows the skills you have mastered, and those that need more practice, so you can maximize your practice time between lessons.",
    },
  ],
  ca: [
    {
      head: "DMV-Certified Driving Lessons for Teens",
      text: "Our school is certified by the DMV, and our lessons are perfect for teens needing the required 6 hours of training with an instructor so you can qualify to take your test, and have the skills and confidence you need to pass it.",
    },
    {
      head: "DMV-Certified Driving Lessons for Adults",
      text: "We teach adult drivers how to become safer and more confident every day. Whether it's your first time driving in California or you need to practice for a Supplemental Driving Performance Evaluation, our expert instructors are here for you.",
    },
    {
      head: "California's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the state's top driving educators.",
    },
    {
      head: "Two-Hour Lessons",
      text: "A typical Coastline lesson is two hours long and is customized to your needs and skill level. The time starts from when we pick you up and ends when we drop you off. There is never another student in the car: your time is YOUR time.",
    },
    {
      head: "Will you Pass Your Test?",
      text: "Good drivers pass the test. So we focus on core skills first, ensuring you are set up to be safe and confident for life, before worrying about the test. On your last lesson, we will do a mock test to be sure you are ready!",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you. All minors in California require 6 hours of professional instruction, which is three lessons, and we will work with you if it is in your best interest to do more.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
    {
      head: "Post-Lesson Report Included",
      text: "At the end of your lesson, your instructor fills out a post-lesson report that shows the skills you have mastered, and those that need more practice, so you can maximize your practice time between lessons.",
    },
  ],
  co: [
    {
      head: "DMV-Certified Driving Lessons for Teens",
      text: "Our school is certified by the Colorado DMV, and our lessons are perfect for teens needing the required 6 hours of training with an instructor so you can qualify to take your test, and have the skills and confidence you need to pass it.",
    },
    {
      head: "DMV-Certified Driving Lessons for Adults",
      text: "We teach adult drivers how to become safer and more confident every day. Whether it's your first time driving in Colorado or your first time driving, our passionate instructors are here for you.",
    },
    {
      head: "Colorado's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the state's top driving educators.",
    },
    {
      head: "Two-Hour Lessons",
      text: "A typical Coastline lesson is two hours long and is customized to your needs and skill level. The time starts from when we pick you up and ends when we drop you off. There is never another student in the car: your time is YOUR time.",
    },
    {
      head: "Will you Pass Your Test?",
      text: "Good drivers pass the test. So we focus on core skills first, ensuring you are set up to be safe and confident for life, before worrying about the test. On your last lesson, we will do a mock test to be sure you are ready!",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you. Most minors in Colorado require 6 hours of professional instruction, which is three lessons, and we will work with you if it is in your best interest to do more.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
    {
      head: "Post-Lesson Report Included",
      text: "At the end of your lesson, your instructor fills out a post-lesson report that shows the skills you have mastered, and those that need more practice, so you can maximize your practice time between lessons.",
    },
  ],
  in: [
    {
      head: "BMV-Certified Driving Lessons for Teens",
      text: "Our school is certified by the BMV, and our lessons are perfect for teens needing the required 6 hours of training with an instructor so you can qualify to take your test, and have the skills and confidence you need to pass it.",
    },
    {
      head: "BMV-Certified Driving Lessons for Adults",
      text: "We teach adult drivers how to become safer and more confident every day. Whether it's your first time driving in Indiana or you need to practice for a drive test, our expert instructors are here for you.",
    },
    {
      head: "Indiana's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the state's top driving educators.",
    },
    {
      head: "One-Hour Lessons",
      text: "A typical Coastline lesson is one hour long and is customized to your needs and skill level. The time starts from when we pick you up and ends when we drop you off. There is never another student in the car: your time is YOUR time.",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you. All minors in Indiana require 6 hours of professional instruction, which is six lessons, and we will work with you if it is in your best interest to do more.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
  ],
  mo: [
    {
      head: "Driving Lessons for Teens",
      text: "Our lessons are designed to give you the confidence you need to be a safe and confident driver for life.",
    },
    {
      head: "Driving Lessons for Adults",
      text: "We teach adult drivers how to become safer and more confident every day. Whether it's your first time driving in the USA or you need to practice for a driving test, our expert instructors are here for you.",
    },
    {
      head: "Missouri's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the state's top driving educators.",
    },
    {
      head: "Two-Hour Lessons",
      text: "A typical Coastline lesson is two hours long and is customized to your needs and skill level. The time starts from when we pick you up and ends when we drop you off.",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
    {
      head: "Post-Lesson Report Included",
      text: "At the end of your lesson, your instructor fills out a post-lesson report that shows the skills you have mastered, and those that need more practice, so you can maximize your practice time between lessons.",
    },
  ],
  nv: [
    {
      head: "Driving Lessons for Teens",
      text: "Our lessons are designed to give you the confidence you need to be a safe and confident driver for life.",
    },
    {
      head: "Driving Lessons for Adults",
      text: "We teach adult drivers how to become safer and more confident every day. Whether it's your first time driving in the USA or you need to practice for a driving test, our expert instructors are here for you.",
    },
    {
      head: "Nevada's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the state's top driving educators.",
    },
    {
      head: "Two-Hour Lessons",
      text: "A typical Coastline lesson is two hours long and is customized to your needs and skill level. The time starts from when we pick you up and ends when we drop you off.",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
    {
      head: "Post-Lesson Report Included",
      text: "At the end of your lesson, your instructor fills out a post-lesson report that shows the skills you have mastered, and those that need more practice, so you can maximize your practice time between lessons.",
    },
  ],
  tx: [
    {
      head: "Certified Driving Lessons for Teens",
      text: "Coastline is licensed by the TDLR, and our lessons are perfect for teens needing the required 7 hours behind the wheel and 7 hours of observation so you can take your test and have the skills and confidence you need to pass it.",
    },
    {
      head: "Driving Lessons for Adults",
      text: "We teach adult drivers how to become safer and more confident every day. Whether it's your first time driving in the USA or you need to practice for a driving test, our expert instructors are here for you.",
    },
    {
      head: "Texas's Top Instructors",
      text: "Our hiring standards and training program go beyond the industry standard. When you choose Coastline Academy, you are choosing the state's top driving educators.",
    },
    {
      head: "Two-Hour Lessons",
      text: "A typical Coastline lesson is two hours long and is customized to your needs and skill level. The time starts from when we pick you up and ends when we drop you off.",
    },
    {
      head: "Will you Pass Your Test?",
      text: "Good drivers pass the test. So we focus on core skills first, ensuring you are set up to be safe and confident for life, before worrying about the test. On one of your last lessons, we will do a mock test to be sure you are ready!",
    },
    {
      head: "How Many Lessons do you Need?",
      text: "Every driver is different, which is why every Coastline lesson is customized for you. All minors in Texas require 7 hours of professional driving instruction and 7 hours of observation.",
    },
    {
      head: "Our Car, Our Insurance",
      text: "We provide all the tools and materials needed for your lesson, so all you need to bring is a positive attitude toward learning a new skill.",
    },
    {
      head: "Post-Lesson Report Included",
      text: "At the end of your lesson, your instructor fills out a post-lesson report that shows the skills you have mastered, and those that need more practice, so you can maximize your practice time between lessons.",
    },
  ],
}

// This block describes what the lessons are all about.

const AboutLessons = ({ USState }) => {
  const stateFeatures =
    USState && allAboutLessons[USState]
      ? allAboutLessons[USState]
      : allAboutLessons.generic

  return (
    <Section
      head="Driving Lessons Customized for You"
      subhead="Every lesson is custom-made to help you succeed."
    >
      <Grid container spacing={5}>
        {stateFeatures.map((feature) => (
          <Grid item xs={12} md={6} key={feature.head}>
            <IconTextBlock head={feature.head} text={feature.text} />
          </Grid>
        ))}
      </Grid>
    </Section>
  )
}

AboutLessons.propTypes = {
  USState: PropTypes.string,
}

AboutLessons.defaultProps = {
  USState: "ca",
}

export default AboutLessons
